//@ts-nocheck
import React from 'react'
import { connect } from 'react-redux'
import { loadingActions } from 'loankeeper-common/components/hocs/LazyLoading'
import { translate } from 'loankeeper-common/helpers'
import { actions as LKModalActions } from '../LKModal'
import _get from 'lodash/get'
import { destroyAccEntryInitialFields } from 'src/store/accEntry'

function getLocalState(obj, key) {
  if (obj?.hasOwnProperty(key)) return obj[key]

  for (let prop in obj) {
    if (typeof obj[prop] === 'object') {
      const result = getLocalState(obj[prop], key)
      if (result) return result
    }
  }
  return undefined
}

const getDataNew = (state, subState: string) => {
  return getLocalState(state, subState).data
}
const getErrorNew = (state, subState: string) => {
  return getLocalState(state, subState).error
}
const getPendingNew = (state, subState: string) => {
  return getLocalState(state, subState).status === 'loading'
}

const getFetchSucceededNew = (state, subState: string) => {
  return getLocalState(state, subState).status === 'loaded'
}

const getInstanceExistenceNew = (state, subState: string) => {
  return Boolean(getLocalState(state, subState).data)
}

// const getDataNew = (state, subState: string) => {
//   return _get(state, subState).data
// }
// const getErrorNew = (state, subState: string) => {
//   return _get(state, subState).error
// }
// const getPendingNew = (state, subState: string) => {
//   return _get(state, subState).status === 'loading'
// }

// const getFetchSucceededNew = (state, subState: string) => {
//   return _get(state, subState).status === 'loaded'
// }

// const getInstanceExistenceNew = (state, subState: string) => {
//   return Boolean(_get(state, subState).data)
// }

// const destroy = (subState: string) => {
//   switch (subState) {
//     case 'accEntryInitialFields':
//       return destroyAccEntryInitialFields()
//   }
// }

const withFetcherHoc =
  ({ fetcherName, APICall, getDataFromResponse, transform, completeAction, withLoading, renderChild, destroy }) =>
  (Component) => {
    class WithFetcher extends React.Component {
      static defaultProps = {
        loading: true,
        renderChild: false,
      }

      componentDidMount() {
        if (!this.props.fetched && !this.props.fetchSucceeded) {
          this.props.makeAPIRequest()
        }
      }

      shouldComponentUpdate(nextProps) {
        if (nextProps.instanceExists) return true

        return false
      }

      render() {
        const { loading, error } = this.props

        const newProps = {
          ...this.props,
          ...getDataFromResponse(this.props.fetchedData),
        }

        delete newProps.fetcherName
        delete newProps.APICall
        delete newProps.APIParams
        delete newProps.loading
        delete newProps.fetchedData
        delete newProps.error
        if (this.props.fetched) {
          return <Component {...newProps} />
        }
        return (loading || error) && !renderChild ? null : <Component loading={loading} {...newProps} />
      }
    }

    const mapStateToProps = (state, props) => ({
      loading: getPendingNew(state, fetcherName || props.fetcherName),
      fetchedData: getDataNew(state, fetcherName || props.fetcherName) || {},
      error: getErrorNew(state, fetcherName || props.fetcherName),
      instanceExists: getInstanceExistenceNew(state, fetcherName || props.fetcherName),
      fetchSucceeded: getFetchSucceededNew(state, fetcherName || props.fetcherName),
    })

    const mapDispatchToProps = (dispatch, props) => ({
      makeAPIRequest: () => {
        if (withLoading) {
          loadingActions.start()
        }

        const apiCall = APICall || props.APICall

        return dispatch(apiCall(props.APIParams)).then((response) => {
          if (apiCall.fulfilled.match(response)) {
            if (withLoading) {
              loadingActions.stop()
            }

            if (completeAction) {
              dispatch(completeAction(transform ? transform(response.payload) : response.payload, props))
            }
            if (destroy) {
              setTimeout(() => {
                dispatch(destroy())
              }, 10)
            }
          } else {
            if (withLoading) {
              loadingActions.stop()
            }

            const code = response.payload

            dispatch(LKModalActions.openError(translate(`LKMESSAGE-${response.payload}`), code))

            if (props.closeModal) {
              props.closeModal()
            }
            throw { Error: { Message: response.payload } }
          }
        })
      },
    })

    return connect(mapStateToProps, mapDispatchToProps)(WithFetcher)
  }

export default withFetcherHoc
